import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    fetchLedmodule, setTemporaryLedmodule,
    updateLedmodule, createLedmodule,
    resetLedmodule, copyLedmodule,
    downloadLedmodule, fetchOriginalLedmodule,
    addIssues
} from '../../../actions';
import { addRecentLedmodule, removeRecentLedmodule } from '../../../utils/recentLedmodulesUtility';
import LedmodulePlaceholder from './LedmodulePlaceholder';
import { Button, Modal, Spinner } from 'react-bootstrap';
import LedmoduleHeader from './ledmoduleShow/LedmoduleHeader';
import LedmoduleDriver from './ledmoduleShow/ledmoduleInfo/LedmoduleDriver';
import { X_API_KEY } from '../../../utils/authentication';
import _ from 'lodash';
import { errorEnum } from '../../../utils/validationSummary';

class Ledmodule extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            changedProperties: {},

            ledmoduleName: '',
            ledmoduleDescription: '',
            ledmoduleType: '',

            disabled: false,
            disabledInfo: false,
            disabledClassName: '',

            isShowingWarningNewLedmodule: false,
            isShowingWarningErrors: false,
            isShowingDeleteLedmoduleForDemo: false,
        };
        
        this.saveLedmodule = this.saveLedmodule.bind(this);
        this.publishLedmodule = this.publishLedmodule.bind(this);
        this.openCopyLedmodulePopup = this.openCopyLedmodulePopup.bind(this);
        this.copyLedmodule = this.copyLedmodule.bind(this);
        this.downloadLedmodule = this.downloadLedmodule.bind(this);

        this.handleChangeLedmoduleInfo = this.handleChangeLedmoduleInfo.bind(this);
        this.handleChangeDriverProperties = this.handleChangeDriverProperties.bind(this);

        this.handleCloseModalNewLedmodule = this.handleCloseModalNewLedmodule.bind(this);
    }

    componentDidMount() {

        if (this.props.match.params.id === 'new') {
            // Creating a new Module
            this.props.fetchOriginalLedmodule().then(() => {
                this.setState({
                    // ledmoduleName: this.props.ledmodule.name,
                    // ledmoduleDescription: this.props.ledmodule.description,
                    ledmoduleType: "P",
                })

                this.refreshButtons();
            });
        } else {
             // Fetch of the ledmodule
            this.props.fetchLedmodule(this.props.match.params.id)
                .then(() => {                    
                    this.setState({
                        ledmoduleName: this.props.ledmodule.name,
                        ledmoduleDescription: this.props.ledmodule.description,
                        ledmoduleType: this.props.ledmodule.type,
                    }, () => {
                        addRecentLedmodule(this.getEditedLedModule());
                        this.refreshButtons();
                    });
                })
                .catch(err => {
                    console.error(err);
                    removeRecentLedmodule(this.props.match.params.id);
                    this.props.history.push('/');
                });
        }
    }

    refreshButtons() {
        if (this.props.match.params.id === 'new') {

            this.setState({
                saveLedmoduleButtonText: "Create Module",
                publishLedmoduleButtonText: "Publish Module",
                copyLedmoduleButtonText: "Save as new ledmodule",
                downloadLedmoduleButtonText: "Download Module",
            });

        } else {                    
            this.setState({
                saveLedmoduleButtonText: this.props.ledmodule.isPublished ? "Create From" : "Save Module",
                copyLedmoduleButtonText: "Save as new ledmodule",
                publishLedmoduleButtonText: "Publish Module",
                downloadLedmoduleButtonText: "Download Module"
            });
        }
    }

    getEditedLedModule() {
        return {
            id: this.props.ledmodule.id,
            creationDate: this.props.ledmodule.creationDate,
            name: this.state.ledmoduleName,
            description: this.state.ledmoduleDescription,
            typy: this.state.ledmoduleType,
        };
    }

    static getDerivedStateFromProps(props, state) {

        if (state.properties === undefined || state.properties === null || Object.keys(state.properties).length === 0) {

            const state = {
                properties: JSON.parse(JSON.stringify(Object.values(props.ledmoduleProperties)))
            };
            if (props.match.params.id === 'new') {
                state.changedProperties = JSON.parse(JSON.stringify(props.ledmoduleProperties));
            }

            return state;
        }

        return null;
    }

    stopLoader(buttonName, text) {
        //stopping loader
        if (buttonName && text) {
            this.setState({ [buttonName]: text });
        }
        this.setState({ disabledInfo: false });
        this.setState({ disabledClassName: '' });
        this.setState({ disabled: false });
    }

    startLoading(buttonName, text) {
        //starting loader
        this.setState({
            [buttonName]:
                <div>
                    <Spinner
                        style={{ marginRight: "0.25rem" }}
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    {text}
                </div>
        });
        this.setState({ disabledInfo: true });
        this.setState({ disabledClassName: "card-disabled" });
        this.setState({ disabled: true });
    }

    publishLedmodule() {

        //starting loader
        this.startLoading('publishLedmoduleButtonText', 'publishing');
        //update ledmodule data
        const ledmodule = {
            id: this.props.ledmodule.id,
            name: this.state.ledmoduleName,
            description: this.state.ledmoduleDescription,
            type: this.state.ledmoduleType,
            isPublished: true,
            properties: JSON.parse(JSON.stringify(Object.values(this.state.changedProperties))),
        };
        this.props.updateLedmodule(this.props.match.params.id, ledmodule).then(() => {
            addRecentLedmodule(this.getEditedLedModule());
            this.props.fetchLedmodule(this.props.match.params.id).then(() => {
                this.stopLoader();
                this.refreshButtons();
            });
        })
        .catch((error) => {
            //stopping loader
            this.refreshButtons();
        });
    }

    // ------ START SAVE LED MODULE 

    saveLedmodule() {

        // If it is temporary and not all properties has been flled show errors
        if (this.state.ledmoduleName === undefined || this.state.ledmoduleName === null || this.state.ledmoduleName.trim() === '') {
            return;
        }

        //starting loader
        this.startLoading('saveLedmoduleButtonText', 'saving');

        //update ledmodule data
        const ledmodule = {
            name: this.state.ledmoduleName,
            description: this.state.ledmoduleDescription,
            type: this.state.ledmoduleType,
            properties: JSON.parse(JSON.stringify(Object.values(this.state.changedProperties))),
        };
        if (this.props.match.params.id === 'new') {
            this.props.createLedmodule(ledmodule).then(() => {
                addRecentLedmodule(this.getEditedLedModule());
                this.stopLoader();
                this.refreshButtons();
                if (this.props.errors.length === 0) {
                    //Redirect to the new ledmodule
                    this.props.history.push(`/ledmodules/${this.props.ledmodule.id}/info`);
                    window.location.reload();
                }
            })
            .catch((error) => {
                //stopping loader
                this.stopLoader();
                this.refreshButtons();
            });
        } else {
            ledmodule.id = this.props.ledmodule.id;
            this.props.updateLedmodule(this.props.match.params.id, ledmodule).then(() => {
                if (this.props.errors.length === 0) {
                    if (this.props.match.params.id !== (''+this.props.ledmodule.id)) {
                        //Redirect to the new ledmodule
                        this.props.history.push(`/ledmodules/${this.props.ledmodule.id}/info`);
                        window.location.reload();
                    } else {
                        this.setState({
                            // ledmoduleName: this.props.ledmodule.name,
                            // ledmoduleDescription: this.props.ledmodule.description,
                            changedProperties: {},
                        })
                        this.props.fetchLedmodule(this.props.match.params.id).then(() => {
                    
                            addRecentLedmodule(this.getEditedLedModule());
                            this.stopLoader();
                            this.refreshButtons();
                        });
                    }
                }
                else {
                    this.stopLoader();
                    this.refreshButtons();
                }
            })
            .catch((error) => {
                //stopping loader
                this.stopLoader();
                this.refreshButtons();
            });
        }
    };

    // ------ END SAVE LED MODULE

    // ------ START COPY AD NEW LED MODULE

    openCopyLedmodulePopup() {

        //starting loader
        this.setState({ isShowingWarningNewLedmodule: true });
        this.setState({ ledmoduleName: this.props.ledmodule.name });

        this.setState({
            copyLedmoduleButtonText:
                <div>
                    <Spinner
                        style={{ marginRight: "0.25rem" }}
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    Saving
                </div>
        });

        this.setState({ disabledInfo: true });
        this.setState({ disabledClassName: 'card-disabled' });
        this.setState({ disabled: true });
    };

    copyLedmodule() {
        this.props.copyLedmodule(this.props.match.params.id, this.state.ledmoduleName)
            .then((id) => {
                this.handleCloseModalNewLedmodule();

                this.props.history.push('/ledmodules/' + this.props.ledmodule.id + '/info');
                //this.props.history.go('/ledmodules/' + this.props.ledmodule.id + '/info');
            });
    }

    handleCloseModalNewLedmodule() {
        this.setState({ isShowingWarningNewLedmodule: false });
        this.setState({ copyLedmoduleButtonText: "Save as new ledmodule" });
        this.setState({ disabledInfo: false });
        this.setState({ disabledClassName: '' });
        this.setState({ disabled: false });
    }

    // ------ END COPY AD NEW LED MODULE

    // ------ START DOWNLOAD LED MODULE

    downloadLedmodule() {

        //starting loader
        this.startLoading('downloadLedmoduleButtonText', 'downloading');

        this.props.downloadLedmodule(this.props.match.params.id)
            .then(() => {
                let res = this.props.file;
                let filename = `Ledmodule-${this.props.match.params.id}.xml`;
                if (res.headers['content-disposition']) {

                    const contentDisposition = res.headers['content-disposition'];
                    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }
                }
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                //stopping loader
                this.stopLoader();
                this.refreshButtons();

                if (localStorage.getItem(X_API_KEY) !== undefined && localStorage.getItem(X_API_KEY) !== null && localStorage.getItem(X_API_KEY) === '') {
                    this.setState({ isShowingDeleteLedmoduleForDemo: true });
                }
            })
            .catch((error) => {
                //stopping loader
                this.stopLoader();
                this.refreshButtons();
            });
    }

    // ------ END DOWNLOAD LED MODULE

    handleCloseModalDeleteLedmoduleForDemo() {
        this.setState({ isShowingDeleteLedmoduleForDemo: false });

        this.props.history.push('/');
    }

    componentWillUnmount() {

        // if (!this.props.ledmoduleIsTemporary) {
        //     addRecentLedmodule(this.getEditedLedModule());
        // }

        this.props.resetLedmodule();
    }

    handleChangeLedmoduleInfo(event) {

        const name = '' + event.target.name;
        const v = '' + event.target.value;

        console.log("CHANGE [", name, "] in [", v, "]");

        this.setState({ [name]: v });
    }

    handleChangeDriverProperties(propertyName, value) {
        
        const name = '' + propertyName;
        const v = '' + value;
        console.log("CHANGE [", name, "] in [", v, "]");

        this.setState(function(prevState, props){
            const changedProperties = prevState.changedProperties;
            if (!(name in changedProperties) || changedProperties[name].value !== v) {
                const p1 = JSON.parse(JSON.stringify(props.ledmoduleProperties[name]));
                p1.value = v;
                changedProperties[name] = p1;
            }

            this.checkProperties(props.ledmoduleProperties, changedProperties);

            return { 
                changedProperties: changedProperties,
            };
        });
    }

    checkProperties(properties, changedProperties) {
        const messages = [];
        Object.values(changedProperties).forEach(property => {
            if (property.valueMeta.min !== undefined && property.valueMeta.min !== null && +property.valueMeta.min > +property.value) {
                messages.push({
                    name: "Value is not in min max range of the property",
                    description: `Minimum ${property.info.name} is ${property.valueMeta.min}`,
                    type: errorEnum,
                    relatedProperties: [
                        property.id
                    ]
                });
            }
    
            if (property.valueMeta.max !== undefined && property.valueMeta.max !== null && +property.valueMeta.max < +property.value) {
                messages.push({
                    name: "Value is not in min max range of the property",
                    description: `Maximum ${property.info.name} is ${property.valueMeta.max}`,
                    type: errorEnum,
                    relatedProperties: [
                        property.id
                    ]
                });
            }
        });

        Object.values(properties).forEach(property => {
            if (changedProperties[property.info.name]) {
                return;
            }

            if (property.valueMeta.min !== undefined && property.valueMeta.min !== null && +property.valueMeta.min > +property.value) {
                messages.push({
                    name: "Value is not in min max range of the property",
                    description: `Minimum ${property.info.name} is ${property.valueMeta.min}`,
                    type: errorEnum,
                    relatedProperties: [
                        property.info.name
                    ]
                });
            }
    
            if (property.valueMeta.max !== undefined && property.valueMeta.max !== null && +property.valueMeta.max < +property.value) {
                messages.push({
                    name: "Value is not in min max range of the property",
                    description: `Maximum ${property.info.name} is ${property.valueMeta.max}`,
                    type: errorEnum,
                    relatedProperties: [
                        property.info.name
                    ]
                });
            }
        });

        this.props.addIssues(messages);
    }

    isLedModuleEdited() {
        return !(Object.keys(this.state.changedProperties).length === 0 
                    && this.state.ledmoduleName === this.props.ledmodule.name
                    && this.state.ledmoduleDescription === this.props.ledmodule.description
                    && this.state.ledmoduleType === this.props.ledmodule.type);
    }
    
    render() {

        if (!this.props.match.params.id || !this.props.ledmodule || !this.props.ledmoduleProperties) {
            return (<LedmodulePlaceholder />);
        }

        return (
            <Router>
                <LedmoduleHeader
                    ledmodule={this.props.ledmodule}
                    disabled={this.state.disabled}
                    ledmoduleIsNew={this.props.match.params.id === 'new'}
                    ledmoduleEdited={this.isLedModuleEdited()}
                    ledmoduleName={this.state.ledmoduleName}
                    saveLedmodule={this.saveLedmodule}
                    saveLedmoduleButtonText={this.state.saveLedmoduleButtonText}
                    publishLedmodule={this.publishLedmodule}
                    publishLedmoduleButtonText={this.state.publishLedmoduleButtonText}
                    copyLedmodule={this.openCopyLedmodulePopup}
                    copyLedmoduleButtonText={this.state.copyLedmoduleButtonText}
                    downloadLedmodule={this.downloadLedmodule}
                    downloadLedmoduleButtonText={this.state.downloadLedmoduleButtonText} />

                <Switch>
                    <Route path="/ledmodules/:id/info" render={
                        (routeProps) => (
                            <LedmoduleDriver {...routeProps}
                                disabledInfo={this.state.disabledInfo}
                                disabledClassName={this.state.disabledClassName}
                                ledmodule={this.props.ledmodule}
                                ledmoduleErrors={this.state.ledmoduleErrors}
                                ledmoduleProperties={this.state.properties}
                                ledmoduleName={this.state.ledmoduleName}
                                ledmoduleDescription={this.state.ledmoduleDescription}
                                ledmoduleType={this.state.ledmoduleType}
                                handleChangeLedmoduleInfo={this.handleChangeLedmoduleInfo}
                                handleChangeDriverProperties={this.handleChangeDriverProperties} />
                        )
                    } />
                </Switch>

                {/* <Modal show={this.state.isShowingWarningNewLedmodule} onHide={this.handleCloseModalNewLedmodule} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}>Save as new ledmodule</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form.Group as={Col} md="12" controlId="name">
                            <Form.Label>New Ledmodule name</Form.Label>
                            <Form.Control
                                required
                                name="ledmodule"
                                type="text"
                                value={this.state.ledmoduleName}
                                onChange={this.handleChangeNameLedmodule.bind(this)}
                                placeholder="Ledmodule name"
                            />
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={this.copyLedmodule}>Save as new</Button>
                    </Modal.Footer>
                </Modal> */}

                <Modal show={this.state.isShowingWarningErrors} onHide={this.handleCloseModalErrors} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#FF6600" }}>Error</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            The download of production file is not available since there are some errors.
                            <br />Please fix them and then retry.
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModalErrors}>Ok</Button>
                    </Modal.Footer>
                </Modal>
            </Router>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ledmodule: state.ledmodule.info,
        ledmoduleProperties: _.mapKeys(state.ledmodule.properties, 'info.name'),
        ledmoduleIsTemporary: state.ledmodule.isTemporary,
        downloadId: state.ledmodule.downloadId,
        file: state.ledmodule.file,
        errors: state.errorsHandler.errors,
        notFound: state.errorsHandler.notFound,
    };
};

const mapDispatchToProps = {
    copyLedmodule,
    fetchLedmodule,
    createLedmodule,
    updateLedmodule,
    downloadLedmodule,
    resetLedmodule,
    setTemporaryLedmodule,
    fetchOriginalLedmodule,
    addIssues,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ledmodule);
